(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function prefillContactFormFromProductQuery() {
    var params = new URLSearchParams(window.location.search);
    var product = params.get('product');
    if (!product) return;

    document.querySelectorAll('.contact-form__form').forEach(function (form) {
      if (form.dataset.prefillInit) return;
      form.dataset.prefillInit = 'true';

      var textarea = form.querySelector('.contact-form__input--textarea');
      if (!textarea || textarea.value.trim() !== '') return;

      var productUrl = params.get('product_url');
      var message =
        'Hi, I\'m interested in "' + product + '" from the Studio Collection and would like to request pricing and availability.';
      if (productUrl) {
        message += '\n\nProduct: ' + window.location.origin + productUrl;
      }
      textarea.value = message;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillContactFormFromProductQuery);
  } else {
    prefillContactFormFromProductQuery();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    function syncFounderImageHeight() {
    document.querySelectorAll('[class*="__founder_row"]').forEach(function (row) {
      var textBox = row.querySelector('[class*="__founder_text"]');
      var wrapper = row.querySelector('[class*="__founder_image"]');
      if (!textBox || !wrapper) return;
      var img = wrapper.querySelector('img');
      if (!img) return;
      var targetHeight = textBox.getBoundingClientRect().height;
      if (targetHeight > 0) {
        wrapper.style.setProperty('--size-style-width', 'auto');
        img.style.height = targetHeight + 'px';
        img.style.width = 'auto';
      }
    });
  }
  window.addEventListener('load', syncFounderImageHeight);
  window.addEventListener('resize', syncFounderImageHeight);
  document.addEventListener('shopify:section:load', syncFounderImageHeight);
  } catch(e) { console.error(e); }
})();

})();
